export enum SectorType {
  Commercial = 'Commercial',
  HigherEd = 'Higher Education',
  Industrial = 'Industrial',
  K12 = 'K-12',
  StateAndLocalGov = 'State and Local Government',
  Other = 'Other',
}
